import { Fragment, memo } from 'react';
import {
  isExistAnyRehabData,
  lineHeightStyle,
  itemTitleStyle,
  isHiddenInPrint,
} from '../../../../utils/helpers';
import RehabItem from './rehabItem';
import { useSelector } from 'react-redux';

const RehabilitationView = ({
  element,
  selectedRehabilitation,
  setSelectedRehabilitation,
  setShowRehabilitation,
  prescriptionItems,
  isHistoryPage = false,
}) => {
  const userInfo = useSelector((state) => state.authReducer.data);
  let { physicalTherapies, exercises, orthoses } = selectedRehabilitation;

  const removeData = (type, itemName) => {
    if (type === 'physicalTherapy') {
      selectedRehabilitation.physicalTherapies = physicalTherapies.filter(
        (data) => data.name !== itemName,
      );
    } else if (type === 'exercise') {
      selectedRehabilitation.exercises = exercises.filter(
        (data) => data.name !== itemName,
      );
    }
    if (type === 'orthosis') {
      selectedRehabilitation.orthoses = orthoses.filter(
        (data) => data.name !== itemName,
      );
    }
    setSelectedRehabilitation({ ...selectedRehabilitation });
  };

  return (
    <div
      className={`row item-row ${
        !isExistAnyRehabData(selectedRehabilitation)
          ? 'no-data-item'
          : 'data-item'
      }`}
      key={`rehabilitation-view`}
    >
      <span
        className={`prescription-item ${
          isHiddenInPrint(prescriptionItems, 'rehabilitation')
            ? 'item-title-hide'
            : ''
        }`}
        style={itemTitleStyle(
          prescriptionItems?.items?.rehabilitation?.itemStyle || {},
        )}
        {...(!isHistoryPage
          ? {
              onClick: (e) => {
                e.stopPropagation();
                setShowRehabilitation(true);
              },
            }
          : {})}
      >
        {element?.alterName?.length ? (
          <span>{element?.alterName}</span>
        ) : (
          <span> Rehabilitation</span>
        )}
      </span>
      {physicalTherapies?.length > 0 && (
        <Fragment>
          {userInfo.id && userInfo.id !== '682601b1423df2768e0c2be4' && (
            <div className="pl-2" style={{ width: '100%' }}>
              Physical Modalities:
            </div>
          )}
          <ul
            className="sub-child-list rehab-ul"
            style={lineHeightStyle('rehabilitation', prescriptionItems)}
          >
            <RehabItem
              rehabItems={physicalTherapies}
              removeData={removeData}
              type="physicalTherapy"
              isHistoryPage={isHistoryPage}
            />
          </ul>
        </Fragment>
      )}
      {exercises?.length > 0 && (
        <Fragment>
          {userInfo.id && userInfo.id !== '682601b1423df2768e0c2be4' && (
            <div className="pl-2" style={{ width: '100%' }}>
              Therapeutic Exercise:
            </div>
          )}
          <ul
            className="sub-child-list"
            // style={lineHeightStyle('rehabilitation', prescriptionItems)}
            style={{
              lineHeight:
                userInfo.id && userInfo.id === '682601b1423df2768e0c2be4'
                  ? '0px'
                  : '20px',
              marginTop:
                userInfo.id && userInfo.id === '682601b1423df2768e0c2be4'
                  ? '-6px'
                  : '0px',
            }}
          >
            <RehabItem
              rehabItems={exercises}
              removeData={removeData}
              type={'exercise'}
              isHistoryPage={isHistoryPage}
            />
          </ul>
        </Fragment>
      )}
      {orthoses?.length > 0 && (
        <Fragment>
          {userInfo.id && userInfo.id !== '682601b1423df2768e0c2be4' && (
            <div className="pl-2" style={{ width: '100%' }}>
              Orthosis:
            </div>
          )}
          <ul
            className="sub-child-list"
            // style={lineHeightStyle('rehabilitation', prescriptionItems)}
            style={{
              lineHeight:
                userInfo.id && userInfo.id === '682601b1423df2768e0c2be4'
                  ? '0px'
                  : '20px',
              marginTop:
                userInfo.id && userInfo.id === '682601b1423df2768e0c2be4'
                  ? '-12px'
                  : '0px',
            }}
          >
            <RehabItem
              rehabItems={orthoses}
              removeData={removeData}
              type={'orthosis'}
              isHistoryPage={isHistoryPage}
            />
          </ul>
        </Fragment>
      )}
    </div>
  );
};

export default memo(RehabilitationView);
